import { cn } from "@u/cn";

type EyebrowProps = React.HTMLAttributes<HTMLElement> & {
  /** Element to render. Use a heading (`h2`/`h3`) when the eyebrow is the
   *  section's semantic heading; default `span` for an inline label. */
  as?: "span" | "p" | "h2" | "h3" | "h4";
};

/**
 * Canonical mono-uppercase section eyebrow — single source for the
 * `text-xs font-mono uppercase tracking-[0.24em] text-muted-foreground` label
 * that was hand-rolled across ~15 dashboard sections. Distinct from `FieldLabel`
 * (a form `<label>`); this is a plain section marker.
 */
export function Eyebrow({ as: Tag = "span", className, ...props }: EyebrowProps) {
  return (
    <Tag
      className={cn(
        "text-xs font-mono uppercase tracking-[0.24em] text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}
